export default "__VITE_ASSET__D0XWo6kC__"